import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const TeeSheetIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 16" title={t`Tee Sheet`} {...props}>
    <Path
      fill="currentColor"
      d="M6 13.25a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1 0-1.5h5Zm9 0a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1 0-1.5h5Zm-12-4a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1 0-1.5h2Zm6 0a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1 0-1.5h2Zm6 0a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1 0-1.5h2Zm-9-4a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1 0-1.5h5Zm9 0a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1 0-1.5h5Zm0-4a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1 0-1.5h14Z"
    />
  </Icon>
);
